import rlaService from './rlaService.js';

export default rlaService;
